import {USER_INFO} from "../actionTypes/user.action-types";


export const setUserInfo = ( user ) => {
    return {
        type: USER_INFO,
        payload: user
    }
};
